import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Logo } from "../components/Logo";
import { adminLogin } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const nav = useNavigate();

  if (localStorage.getItem("monarch_token")) {
    return <Navigate to="/admin" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await adminLogin(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center bg-[var(--m-bg-2)] py-20 px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-[var(--m-bg)] border border-[var(--m-border)] p-10">
        <Logo />
        <div className="gold-divider mt-8" />
        <h1 className="font-display text-3xl mt-6">Admin Console</h1>
        <p className="text-sm text-[var(--m-ink-2)] mt-2">Sign in to view leads and inquiries.</p>

        <form onSubmit={onSubmit} className="mt-10 space-y-6" data-testid="admin-login-form">
          <div>
            <label className="label-tiny">Email</label>
            <input
              className="input-line"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@aconltd.com"
              data-testid="admin-email"
              autoComplete="username"
            />
          </div>
          <div>
            <label className="label-tiny">Password</label>
            <input
              className="input-line"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              data-testid="admin-password"
              autoComplete="current-password"
            />
          </div>
          <button type="submit" disabled={submitting} className="btn-primary w-full justify-center disabled:opacity-50" data-testid="admin-submit">
            {submitting ? <Loader2 size={15} className="animate-spin" /> : <Lock size={15} />}
            Sign In
          </button>
        </form>
      </div>
    </main>
  );
}
